import { postForm, postJson } from '@/utils/http'

/**
 * 手机验证码登录
 * @param {Object} data
 * @param {string} data.mobile - 手机号
 * @param {string} data.captcha - 验证码
 */
export function mobileLogin(data) {
  return postForm('/api/user/mobilelogin', data)
}

/**
 * 获取用户信息
 */
export function fetchUserInfo() {
  return postForm('/api/user/getUserInfo', {})
}

/**
 * 获取用户发布数量
 */
export function fetchUserStats() {
  return postForm('/api/user/getUserStats', {})
}

/**
 * 获取提交信息
 */
export function fetchApplyEngineerInfo() {
  return postForm('/api/user/getApplyEngineerInfo', {})
}

/**
 * 保存用户信息
 * @param {Object} data
 * @param {string} data.nickname - 姓名
 * @param {string} data.avatar - 头像
 * @param {string} data.mobile - 手机号
 * @param {string} data.code - 验证码
 */
export function saveUser(data) {
  return postForm('/api/user/saveUser', data)
}

/**
 * 保存用户资料
 * @param {Object} data
 * @param {string} data.nickname
 * @param {string} data.avatar
 * @param {string} data.mobile
 */
export function saveUserProfile(data) {
  return postForm('/api/user/profile', data)
}

/**
 * 申请成为工程师
 * @param {Object} data
 */
export function applyEngineer(data) {
  return postJson('/api/user/applyEngineer', data)
}

/**
 * 重新提交申请成为工程师
 * @param {Object} data
 */
export function applyEngineerSet(data) {
  return postJson('/api/user/applyEngineerSet', data)
}

/**
 * 解锁查看联系方式
 * @param {Object} data
 * @param {number} data.requirement_id - 需求ID
 */
export function doUnlock(data) {
  return postForm('/api/user/doUnlock', data)
}

/**
 * 查看用户联系方式
 * @param {Object} data
 * @param {number|string} data.requirement_id - 需求ID
 */
export function getPublishInfo(data) {
  return postForm('/api/user/getPublishInfo', data)
}
